<template>
  <div class="financial-statements">
    <RkTabs v-model="activeTab" :options="options" shrink slider />
    <div class="statement-wrapper">
      <keep-alive>
        <component :is="component" :css="css" :mainDataStyle="mainDataStyle"></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import RkTabs from '@/components/common/RkTabs.vue'
import USIncomeStatement from '@/components/f10/statements/IncomeStatement-us.vue'
import USBalanceStatement from '@/components/f10/statements/BalanceStatement-us.vue'
import USCashStatement from '@/components/f10/statements/CashStatement-us.vue'
import USIndicatorsStatement from '@/components/f10/statements/IndicatorsStatement-us.vue'
import HKIncomeStatement from '@/components/f10/statements/incomeStatement-hk/index.vue'
import HKBalanceStatement from '@/components/f10/statements/balanceStatement-hk/index.vue'
import HKCashStatement from '@/components/f10/statements/CashStatement-hk-hs.vue'
import HKHSIndicatorsStatement from '@/components/f10/statements/IndicatorsStatement-hk-hs.vue'
import { sendMsg } from '@/plugins/msg'
const components = {
  hk: {
    indicators: HKHSIndicatorsStatement,
    income: HKIncomeStatement,
    balance: HKBalanceStatement,
    cash: HKCashStatement
  },
  hs: {
    indicators: HKHSIndicatorsStatement,
    income: HKIncomeStatement,
    balance: HKBalanceStatement,
    cash: HKCashStatement
  },
  us: {
    indicators: USIndicatorsStatement,
    income: USIncomeStatement,
    balance: USBalanceStatement,
    cash: USCashStatement
  }
}
export default {
  components: { RkTabs },
  data() {
    return {
      options: Object.freeze([
        {
          label: '主要指标',
          value: 'indicators'
        },
        {
          label: '利润表',
          value: 'income'
        },
        {
          label: '资产负债表',
          value: 'balance'
        },
        {
          label: '现金流量表',
          value: 'cash'
        }
      ]),
      css: Object.freeze({
        fontSize: '18px',
        color: 'var(--font-color-1)',
        height: '40px',
        fontWeight: 500
      }),
      mainDataStyle: Object.freeze({
        height: '35px',
        fontSize: '18px',
        color: 'var(--font-color-1)',
        fontWeight: 500
      })
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    activeTab: {
      get() {
        return this.$route.query.type
      },
      set(type) {
        this.$router.replace({
          path: '/f10/statements',
          query: {
            symbol: this.symbol,
            type,
            replace: true
          }
        })
      }
    },
    component() {
      return components[this.market][this.activeTab]
    }
  },
  created() {
    sendMsg({ event: 'setTitle', title: '财务数据' })
  }
}
</script>

<style lang="scss">
.financial-statements {
  background: var(--bg-color-2);
  .statement-wrapper {
    padding: 0 var(--edge-padding) var(--edge-padding);
  }
  .financial-statement-item {
    .date-header {
      display: flex;
      justify-content: space-between;

      & > span:first-of-type {
        display: flex;
        align-items: center;
      }

      .tongbi {
        display: flex;
        align-items: center;
      }
      .checkbox-wrap {
        box-sizing: border-box;
        position: relative;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        margin-left: 4px;
        border: 1px solid var(--font-color-3);
      }
      .checkbox {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
    .value-wrap {
      display: flex;
      justify-content: space-between;
      flex: 1;
      .scale {
        flex: 1;
        text-align: right;
        display: none;
      }
      .value {
        flex: 1;
        text-align: right;
        padding-right: 4px;
      }
    }
    .col-table--same {
      .checkbox-wrap {
        position: relative;
        background: var(--main-color-2);
        border: 1px solid transparent;
        &::before {
          content: '√';
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 12px;
          color: var(--bg-color-2);
        }
      }
      .value-wrap {
        .scale {
          display: block;
        }
        .value {
          padding-right: 4px;
        }
      }
    }
    .table-var {
      --col-table-row-padding: 10px 0;
    }
  }
}
</style>
